/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { getPayloadObject, getTelemetryAttributes, IPayLoad, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import classnames from 'classnames';

export interface ICookieComplianceAcceptButton {
    reloading?: boolean;
    acceptCookiesButtonText?: string;
    acceptCookiesButtonAriaLabel?: string;

    /**
     * The telemetry content
     */
    telemetryContent?: ITelemetryContent;
    onClose(): void;
}

export const CookieComplianceAcceptButton: React.FC<ICookieComplianceAcceptButton> = ({
    reloading,
    acceptCookiesButtonText,
    acceptCookiesButtonAriaLabel,
    telemetryContent,
    onClose
}) => {
    const payLoad: IPayLoad = getPayloadObject('click', telemetryContent!, 'accept cookies');
    const attributes = getTelemetryAttributes(telemetryContent!, payLoad);

    return (
        <button
            type='button'
            className={classnames('ms-cookie-compliance__accept-button msc-btn', { 'is-loading': reloading })}
            aria-label={acceptCookiesButtonAriaLabel}
            disabled={reloading}
            onClick={onClose}
            {...attributes}
        >
            {acceptCookiesButtonText}
        </button>
    );
};
